import * as types from './action_types'
const initialState = {
  Table: [],
  crossingCities: [],
  defaultCrossingCity: {},
  crossingBranches: [],
  destinationBranchList: [],
  dispatchInsertResult: [],
  dispatchedLuggaged: [],
  editDispatchRes: [],
  updateDispatchRes: [],
  cancelDispatchRes: [],
  checkinReport: [],
  dispatchMemoData: [],
  busmastertype: false,
  tripMapingData: [],
  crossingData: { crossingCities: [], crossingBranches: [] },
}
const dispatchReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.DISPATCH_ITEM_LIST:
      return Object.assign({}, state, {
        Table: action.data,
      })
    case types.INSERT_DISPATCH_ITEM:
      return Object.assign({}, state, {
        dispatchInsertResult: action.data,
      })
    case types.CROSSING_CITY:
      return Object.assign({}, state, {
        crossingCities: action.data,
      })
    case types.DEFAULT_CROSSING_CITY_BRANCH:
      return Object.assign({}, state, {
        defaultCrossingCity: action.data,
      })
    case types.CROSSING_BRANCH:
      return Object.assign({}, state, {
        crossingBranches: action.data,
      })
    case types.DESTINATION_BRANCH:
      return Object.assign({}, state, {
        destinationBranchList: action.data,
      })
    case types.DISPATCHED_LUGGAGE: {
      return Object.assign({}, state, {
        dispatchedLuggaged: action.data,
      })
    }
    case types.EDIT_DISPATCH: {
      return Object.assign({}, state, {
        editDispatchRes: action.data,
      })
    }
    case types.UPDATE_DISPATCH: {
      return Object.assign({}, state, {
        updateDispatchRes: action.data,
      })
    }

    case types.CANCEL_DISPATCH: {
      return Object.assign({}, state, {
        cancelDispatchRes: action.data,
      })
    }
    case types.CHECKIN_REPORT: {
      return Object.assign({}, state, {
        checkinReport: action.data,
      })
    }
    case types.DISPATCH_MEMO: {
      return Object.assign({}, state, {
        dispatchMemoData: action.data,
      })
    }
    case types.GET_BUS_AND_CARGO_TRIP_MAPING: {
      return {
        ...state,
        tripMapingData: action.data,
      }
    }
    case types.GET_BUS_MASTER_TYPE: {
      return {
        ...state,
        busmastertype: action.data,
      }
    }
    case types.DISPATCH_GLOBAL_STATE_RESET: {
      return {
        ...state,
        busmastertype: false,
      }
    }
    case types.DESTCITY_WITH_CROSSING_BRANCH: {
      return { ...state, crossingData: action.data }
    }
    default:
      return state
  }
}

export default dispatchReducer
